// Node Module Imports
import React from 'react'

import PropTypes from 'prop-types'
import styled from 'styled-components'

// Style Imports
import { colors } from '../../style/design-system'

const TwoColWithBorder = ({
  borderAt, className, content1, content2,
}) => {
  const leftWidth = borderAt - 1
  const rightWidth = 12 - borderAt

  return (
    <div className={className}>
      <div className="container">
        <div className="row">
          <div className={`col-12 col-lg-${leftWidth}`}>
            {content1()}
          </div>
          <div className="d-none d-lg-block col-lg-1 border" />
          <div className={`col-12 col-lg-${rightWidth}`}>
            {content2()}
          </div>
        </div>
      </div>
    </div>
  )
}

TwoColWithBorder.propTypes = {
  borderAt: PropTypes.number.isRequired,
  className: PropTypes.string,
  content1: PropTypes.func.isRequired,
  content2: PropTypes.func.isRequired,
}

TwoColWithBorder.defaultProps = {
  className: '',
}

export default styled(TwoColWithBorder)`

  .border {
    border: none !important;
    text-align: center;

    &::before {
      background-color: ${colors.dev.gray.d()};
      content: '';
      display: block;
      margin: 0 auto;
      position: absolute;
        top: 0; bottom: 0; right: 0; left: 0;
      width: 1px;
    }
  }
`
